import React, { Component } from 'react'
import ExperiencePlace from "../../components/360tour/container"
import Introduction from '../../components/introduction'
import Menubar from "../../components/menubar/container"
import NavigationBar from '../../components/navigator/container'
import Popup from "../../components/popup/container"
import Toolbar from "../../components/toolbar/container"
import store from '../../store'
import { ActionTypes } from './action'
import './App.css'
import Guide from "./Guide"
import { initState } from './reducer'

class App extends Component {
	constructor() {
		super();
		this.state = {
			hiddenFullscreenBtn: false
		};
	}

	init() {
		initState.isReady = true;
		store.dispatch({
			type: ActionTypes.CHANGE_APP_STATE,
			payload: initState
		});
		return (
			<div className="app-mask">
				<Guide />
				<Popup />
			</div>
		)
	}

	getControllerLayerView() {
		var toggleFull = this.props.isToggleFull ? "hidden-controller" : null;
		return <div id="controller-layer" className={toggleFull}>
			<NavigationBar />
			<Menubar />
			<Toolbar />
		</div>
	}

	getAppView() {
		return (
			<div className="App">
				<Introduction skip={window.config.intro?.skip} onIntroComplete={this.init.bind(this)} />
				{this.getControllerLayerView.call(this)}
				<div id="vrtour-layer">
					<ExperiencePlace />
				</div>
			</div>
		);
	}

	componentDidMount() {
		setTimeout(() => {
			this.setState({ hiddenFullscreenBtn: true });
		}, 10000);
	}

	render() {
		return this.getAppView.call(this)
	}
}

export default App;
